<template>
    <div
        class="relative flex items-center w-full col-span-1 px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div class="flex justify-between" v-show="show">
                    <h2
                        ref="scrollToMe"
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ transportation.designation }}
                    </h2>

                    <div @click="removeTransportation">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8"
                            icon-name="trash cursor-pointer"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <tag-group :tags="tags" @clicked="changeBuyingType" />
                    <base-input
                        placeholder="Désignation"
                        v-model="transportation.designation"
                        :hasError="$v.transportation.designation.$error"
                        :errorMessage="
                            errorMessage(
                                'Désignation',
                                $v.transportation.designation
                            )
                        "
                        @blur="$v.transportation.designation.$touch()"
                    />
                    <base-number-input
                        label="Quantité"
                        placeholder="0"
                        v-model="transportation.number"
                        :hasError="$v.transportation.number.$error"
                        :errorMessage="
                            errorMessage('Nombre', $v.transportation.number)
                        "
                        @blur="$v.transportation.number.$touch()"
                    />
                    <base-input
                        placeholder="Caractéristiques"
                        v-model="transportation.characteristics"
                        :hasError="$v.transportation.characteristics.$error"
                        :errorMessage="
                            errorMessage(
                                'Caractéristiques',
                                $v.transportation.characteristics
                            )
                        "
                        @blur="$v.transportation.characteristics.$touch()"
                    />
                    <base-input
                        placeholder="Nom du fournisseur"
                        v-model="transportation.providerName"
                        :hasError="$v.transportation.providerName.$error"
                        :errorMessage="
                            errorMessage(
                                'Nom du fournisseur',
                                $v.transportation.providerName
                            )
                        "
                        @blur="$v.transportation.providerName.$touch()"
                    />
                    <base-number-input
                        :isCurrency="true"
                        label="Prix Unitaire (HT)"
                        placeholder="0"
                        v-if="transportation.BuyingType !== 'location'"
                        v-model="transportation.price"
                        :hasError="$v.transportation.price.$error"
                        :errorMessage="
                            errorMessage(
                                'Prix en DH (HT)',
                                $v.transportation.price
                            )
                        "
                        @blur="$v.transportation.price.$touch()"
                    />

                    <!-- <base-input placeholder="Loyer mensuelle" /> -->
                    <div
                        class="mt-10 ml-3 text-left"
                        v-if="transportation.BuyingType !== 'location'"
                    >
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Origine</label
                        >
                        <radio-box
                            label="Local"
                            name="origine"
                            :value="transportation.origin"
                            @change="
                                payload => {
                                    transportation.origin = payload;
                                }
                            "
                        />
                        <radio-box
                            class="ml-6"
                            label="Étranger"
                            name="origine"
                            :value="transportation.origin"
                            @change="
                                payload => {
                                    transportation.origin = payload;
                                }
                            "
                        />
                    </div>
                    <base-tips-alert
                        v-if="transportation.BuyingType === 'leasing'"
                        color="bg-orange-100 border-orange-400"
                        title="Attention"
                    >
                        <p class="my-0 mt-1 text-gray-700">
                            Veuillez contacter votre banquier pour avoir la
                            simulation de votre crédit de bail.
                        </p>
                    </base-tips-alert>

                    <base-number-input
                        label="Avance (HT)"
                        :isCurrency="true"
                        placeholder="0"
                        v-model="transportation.payedInAdvance"
                        v-if="transportation.BuyingType === 'leasing'"
                    />
                    <base-number-input
                        placeholder="0"
                        :isCurrency="true"
                        label="Loyer mensuel (HT)"
                        v-model="transportation.rentPrice"
                        v-if="
                            transportation.BuyingType === 'leasing' ||
                                transportation.BuyingType === 'location'
                        "
                    />
                    <base-number-input
                        placeholder="0"
                        label="Nombre de mois"
                        v-model="transportation.rentDuration"
                        v-if="transportation.BuyingType === 'leasing'"
                    />

                    <div class="flex justify-end mt-4">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeTransportation"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioBox from "@/components/forms/Toggles/radioBox";
import TagGroup from "@/components/forms/TagGroup";
import IconTrash from "@/components/icons/trash";
import {
    required,
    integer,
    decimal,
    minLength,
    maxLength,
    minValue
} from "vuelidate/lib/validators";

import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToRef } from "@/mixins/scrollToMixin.js";

export default {
    components: { RadioBox, TagGroup, IconTrash },
    props: {
        data: {
            type: Object
        },

        title: {
            type: String
        }
    },

    mixins: [errorMessage, scrollToRef],

    validations() {
        if (this.transportation.BuyingType === "achat") {
            return {
                transportation: {
                    price: { required, decimal, minValue: minValue(0) },
                    designation: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    },
                    number: { integer, minValue: minValue(1) },
                    characteristics: {
                        minLength: minLength(3),
                        maxLength: maxLength(150)
                    },
                    providerName: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    }
                }
            };
        }
        if (this.transportation.BuyingType === "location") {
            return {
                transportation: {
                    rentPrice: { required, decimal, minValue: minValue(0) },
                    designation: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    },
                    number: { integer, minValue: minValue(1) },
                    characteristics: {
                        minLength: minLength(3),
                        maxLength: maxLength(150)
                    },
                    providerName: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    }
                }
            };
        }
        if (this.transportation.BuyingType === "leasing") {
            return {
                transportation: {
                    price: { required, decimal, minValue: minValue(0) },
                    rentPrice: { required, decimal, minValue: minValue(0) },
                    rentDuration: { required, integer, minValue: minValue(0) },
                    payedInAdvance: {
                        required,
                        decimal,
                        minValue: minValue(0)
                    },
                    designation: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    },
                    number: { integer, minValue: minValue(1) },
                    characteristics: {
                        minLength: minLength(3),
                        maxLength: maxLength(150)
                    },
                    providerName: {
                        minLength: minLength(3),
                        maxLength: maxLength(75)
                    }
                }
            };
        }
    },
    data() {
        return {
            show: false,
            transportation: this.data,
            BuyingType: true,
            tags: [
                {
                    name: "Achat en propriété",
                    value: "achat",
                    isActive: false
                },
                { name: "Location", value: "location", isActive: false },
                { name: "Achat en leasing", value: "leasing", isActive: false }
            ]
        };
    },
    mounted() {
        this.tags.forEach(elem => {
            if (elem.value === this.transportation.BuyingType)
                elem.isActive = true;
        });
    },
    methods: {
        changeBuyingType(newValue) {
            this.transportation.BuyingType = newValue;
        },
        removeTransportation() {
            this.$emit("remove", this.transportation.id);
        },
        createTransportation() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "EtudeTechnique/createTransportation",
                    this.transportation
                );
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        }
    }
};
</script>

<style></style>
